


















import Vue from 'vue';
import { ICountry } from '@/common/interfaces/config.interface';
import RemoteDataSelectInputVue from './RemoteDataSelectInput.vue';

interface ICountrySelectInputComponent {
  addCountryWithCodeStringTransformer: (data: ICountry[]) => (ICountry & { withCode: string })[];
}

export default Vue.extend({
  components: {
    RemoteDataSelectInputVue,
  },
  model: {
    event: `change`,
    prop: `value`,
  },
  data(): ICountrySelectInputComponent {
    return {
      addCountryWithCodeStringTransformer: (data: ICountry[]): (ICountry & { withCode: string })[] => {
        return data.map((e: ICountry) => {
          return { ...e, withCode: `${e.name} (${e.code})` };
        });
      },
    };
  },
  computed: {
    textProperty(): string {
      return this.showCode ? `withCode` : `name`;
    },
  },
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    getAllCountries: {
      default: false,
      type: Boolean,
    },
    identifier: {
      default: ``,
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    showCode: {
      default: false,
      type: Boolean,
    },
    showEmptyOption: {
      default: false,
      type: Boolean,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    t: {
      required: true,
      type: Object as () => Record<string, string>,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    title: {
      default: ``,
      type: String,
    },
    value: {
      default: ``,
      type: [String, Number],
    },
  },
});
